export * from '@primeuix/themes/aura/base';
export { default } from '@primeuix/themes/aura/base';
